import { useCallback } from 'react';

import { Skeleton } from '@mui/material';
import { useKeycloakContext } from 'modules/keycloak/context';
import { useAppSelector } from 'store';
import { selectUserAccount } from 'user/api';

import { CurrentUser } from './CurrentUser';

export const CurrentUserContainer = () => {
  const keycloak = useKeycloakContext();
  const userAccount = useAppSelector(selectUserAccount);
  const handleLogout = useCallback(() => keycloak.logout({ redirectUri: window.location.origin }), [keycloak]);

  if (!userAccount) return <Skeleton width={240} />;

  return <CurrentUser account={userAccount} onLogout={handleLogout} />;
};
